export class RegistrationPayment {
    id: number;
    eventRegistrationId: number;
    
    paymentType: string;
    paymentId: string;

    amount: number;

    transactionDate: string;

    constructor() {
        this.paymentType = 'Check';
        this.transactionDate = new Date().toISOString();
        this.transactionDate = this.transactionDate.substring(0, this.transactionDate.indexOf('T'));
    }
}


// WEBPACK FOOTER //
// ./src/model/registrationPayment.ts